import React, { Fragment, useState } from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {
  Button,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import removalsActions from "../../../redux/actions/removals";
import moment from "moment";

const allLocalsOption = { _id: "", name: "Todos los locales" };

const getLocalCustomerId = (local) => {
  const customer = Array.isArray(local.customerID)
    ? local.customerID[0]
    : local.customerID;

  return customer && typeof customer === "object" ? customer._id : customer;
};

export default function SearchBar() {
  const dispatch = useDispatch();
  const utils = useSelector((state) => state.utils);

  const [typeSearch, setTypeSearch] = useState("ALL");
  const [companyID, setCompanyID] = useState("");
  const [localID, setLocalID] = useState("");
  const [transporterSearch, setTransporterSearch] = useState("");
  const [firstParam, setFirstParam] = useState(moment().subtract(3, "months").startOf("day"));
  const [secondParam, setSecondParam] = useState(moment().endOf("day"));
  const [dateRangeError, setDateRangeError] = useState(false);
  const [companyError, setCompanyError] = useState(false);

  const customers = utils.customers || [];
  const locals = utils.locals || [];
  const company = customers.find((customer) => customer._id === companyID);
  const companyLocals = company
    ? locals.filter((local) => getLocalCustomerId(local) === companyID)
    : [];
  const localOptions = [allLocalsOption, ...companyLocals];

  const searchOnClick = () => {
    const startDate = moment(firstParam);
    const endDate = moment(secondParam);

    if (
      !startDate.isValid() ||
      !endDate.isValid() ||
      startDate.isAfter(endDate, "day")
    ) {
      setDateRangeError(true);
      return;
    }

    if (typeSearch === "COMPANY" && !companyID) {
      setCompanyError(true);
      return;
    }

    setDateRangeError(false);
    setCompanyError(false);

    const data = {
      type: typeSearch,
      dateInit: startDate.startOf("day"),
      dateFinish: endDate.endOf("day"),
    };

    if (typeSearch === "COMPANY") {
      data.firstParam = companyID;
      data.secondParam = localID;
    } else if (typeSearch === "TRANSPORTER") {
      data.firstParam = transporterSearch;
    }

    dispatch(removalsActions.setSearch(data));
  };

  return (
    <Fragment>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <TextField
              label="Tipo de búsqueda"
              variant="outlined"
              margin="dense"
              value={typeSearch}
              onChange={(event) => {
                setTypeSearch(event.target.value);
                setCompanyError(false);
              }}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              select
              fullWidth
            >
              <MenuItem value="ALL">Todos</MenuItem>
              <MenuItem value="COMPANY">Empresa</MenuItem>
              <MenuItem value="TRANSPORTER">Transportista</MenuItem>
            </TextField>
          </Grid>

          {typeSearch === "COMPANY" && (
            <Fragment>
              <Grid item xs={12} sm={2}>
                <Autocomplete
                  options={customers}
                  value={company || null}
                  getOptionLabel={(option) => option.brand || ""}
                  getOptionSelected={(option, value) =>
                    option._id === value._id
                  }
                  onChange={(_, selectedCompany) => {
                    setCompanyID(selectedCompany ? selectedCompany._id : "");
                    setLocalID("");
                    setCompanyError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Empresa"
                      variant="outlined"
                      margin="dense"
                      error={companyError}
                      fullWidth
                    />
                  )}
                />
                {companyError && (
                  <FormHelperText error>Seleccione una empresa</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={2}>
                <Autocomplete
                  options={localOptions}
                  value={
                    localOptions.find((local) => local._id === localID) || null
                  }
                  getOptionLabel={(option) => option.name || ""}
                  getOptionSelected={(option, value) =>
                    option._id === value._id
                  }
                  onChange={(_, selectedLocal) =>
                    setLocalID(selectedLocal ? selectedLocal._id : "")
                  }
                  disabled={!company}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Local"
                      variant="outlined"
                      margin="dense"
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Fragment>
          )}

          {typeSearch === "TRANSPORTER" && (
            <Grid item xs={12} sm={2}>
              <TextField
                label="Buscar transportista"
                variant="outlined"
                margin="dense"
                value={transporterSearch}
                onChange={(event) => setTransporterSearch(event.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          )}

          <Grid item xs={6} sm={2}>
            <DatePicker
              label="Fecha inicial"
              inputVariant="outlined"
              value={firstParam}
              onChange={(date) => {
                setFirstParam(date);
                setDateRangeError(false);
              }}
              format="DD/MM/YYYY"
              margin="dense"
              fullWidth
            />
          </Grid>

          <Grid item xs={6} sm={2}>
            <DatePicker
              label="Fecha final"
              inputVariant="outlined"
              value={secondParam}
              onChange={(date) => {
                setSecondParam(date);
                setDateRangeError(false);
              }}
              format="DD/MM/YYYY"
              margin="dense"
              fullWidth
            />
            {dateRangeError && (
              <FormHelperText error>
                La fecha final debe ser mayor o igual a la inicial
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={searchOnClick}
              style={{ marginTop: 10 }}
              startIcon={<SearchIcon />}
              fullWidth
            >
              Buscar
            </Button>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
      <hr />
    </Fragment>
  );
}
